import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { LeadSchema } from "@/lib/leads/leadSchemas";
import { DEFAULT_LEAD_SCHEMAS } from "@/lib/leads/leadSchemas";

export const leadSchemasQueryKeys = {
  all: ["lead-schemas"] as const,
};

export function useLeadSchemas() {
  return useQuery({
    queryKey: leadSchemasQueryKeys.all,
    queryFn: async () => {
      const { data, error } = await supabase.from("lead_schemas").select("*");
      if (error) {
        console.warn("[LeadSchemas] Falling back to defaults:", error.message);
        return DEFAULT_LEAD_SCHEMAS;
      }
      return (data as unknown as Array<{ lead_type_id: string; lead_type_name: string; fields: any }>).map((row) => ({
        leadTypeId: row.lead_type_id,
        leadTypeName: row.lead_type_name,
        fields: row.fields as LeadSchema["fields"],
      }));
    },
  });
}
